<div>
    <div class="descr-heading">Food allergy/intolerance disclaimer</div>
    <div class="descr-details">While we are constantly improving the accuracy
        of food recommendations, the app is still in beta
        and we can not guarantee that the recommended
        restaurants or dishes will cater to your
        food allergy/intolerance. Kindly check with the
        member of staff at the restaurant before making
        your food decision.</div>
    <div class="btn-div">
        <button (click)="closePopUp()">I understand</button>
    </div>
</div>
<style>
    .descr-heading {
        text-align: center;
        font-size: 18px;
        font-weight: 500;
        margin: 13px 0px;
    }

    .descr-details {
        color: #676464;
        font-size: 16px;
        text-align: justify;
        margin-bottom: 16px;
    }

    .btn-div {
        text-align: center;
        margin-bottom: 10px;
    }

    button {
        padding: 10px;
        border-radius: 10px;
        width: 80%;
        background: #0ecc7a;
        color: white;
        font-size: 18px;
        font-weight: 500;
        border: none;
    }
</style>